export type TranscriptSegment =
  | { text: string; isLowConfidence: false }
  | { text: string; isLowConfidence: true; confidence: number };

// NOTE(jonty): Voice transcripts carry speech-to-text markup inline; it is the
// only record of which words the transcriber was unsure of.
const LOW_CONFIDENCE_TAG = 'LowConfTranscript';
const TAGGED_SPAN = /<([A-Za-z]+)([^>]*)>([\s\S]*?)<\/\1>/g;
const STRAY_TAG = /<\/?[A-Za-z][^>]*>/g;
const CONFIDENCE_ATTRIBUTE = /conf=(\d*\.?\d+)/;

export function transcriptSegments(text: string): TranscriptSegment[] {
  const segments: TranscriptSegment[] = [];
  const push = (part: string, confidence?: number) => {
    const clean = part.replace(STRAY_TAG, '');
    if (!clean) return;
    segments.push(
      confidence == null
        ? { text: clean, isLowConfidence: false }
        : { text: clean, isLowConfidence: true, confidence }
    );
  };
  let lastIndex = 0;
  for (const match of Array.from(text.matchAll(TAGGED_SPAN))) {
    const [whole, tag, attributes, inner] = match;
    push(text.slice(lastIndex, match.index));
    push(
      inner,
      tag === LOW_CONFIDENCE_TAG ? confidenceOf(attributes) : undefined
    );
    lastIndex = (match.index ?? 0) + whole.length;
  }
  push(text.slice(lastIndex));
  return segments;
}

function confidenceOf(attributes: string): number {
  return Number(attributes.match(CONFIDENCE_ATTRIBUTE)?.[1] ?? 0);
}
